export const SUPPORTED_MACROS = [
  "IP_ADDRESS",
  "HASHED_IP_ADDRESS",
  "USER_AGENT",
  "IMPRESSION_ID",
  "ADVERTISER_ID",
  "CAMPAIGN_ID",
  "CREATIVE_ID",
  "COUNTRY_CODE",
  "REGION_CODE",
  "CITY_NAME",
  "TIMESTAMP_UTC",
  "RANDOM",
];

const hasPattern = (regexp, value) => regexp.test(value);

export const isValidURLProtocol = (url) => /^(https?:\/\/)/i.test(url);

export const isValidURLDomain = (url) =>
  hasPattern(
    /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z]+)+)+[a-z]{1}(?:\?*)(?:.*)?$/g,
    url
  );

export const hasCurlyBrakets = (pixelUrl) => {
  const macroRegexp = "^(?=.*[{]{1})|(?=.*[}]{1})[^ ]*$";
  return hasPattern(new RegExp(macroRegexp, "g"), pixelUrl);
};

export const atleastOneValidMacro = (pixelUrl, macrosList) => {
  const macros = macrosList.join("}}|{{");
  const macroRegexp = `^(?=.*(?:{{${macros}}})).+$`;
  return hasPattern(new RegExp(macroRegexp, "g"), pixelUrl);
};

export const areSpecialCharactersValid = (pixelUrl) => {
  const specialCharacterRegexp =
    "^(?!.*[_]{2})(?!.*[?]{2})(?!.*[{]{3})(?!.*[}]{3})(?!.*[&]{2})(?!.*[=]{2})(?!.*%(?![0-9A-Fa-f]{2}))(?!.*[[]{1})(?!.*[(]{1})(?!.*[)]{1})(?!.*[|]{1})(?!.*[#]{1})[^\\s]*$";
  return hasPattern(new RegExp(specialCharacterRegexp, "g"), pixelUrl);
};

function listOfPossibleMacros(url) {
  const uppercaseWords = url.match(/(?<=%%|{{|\[\[|\(\()\s*(\w+)\s*(?=%%|}}|\]\]|\)\))/g);
  if (!uppercaseWords) return [];
  const matchingMacros = new Set();
  uppercaseWords.forEach((word) => {
    for (const macro of SUPPORTED_MACROS) {
      if (macro.includes(word.toUpperCase())) {
        matchingMacros.add(`{{${macro}}}`);
      }
    }
  });
  return Array.from(matchingMacros);
}

function detectValidMacros(url) {
  const validMacros = [];
  const regex = /{{([^}]+)}}/g;
  let match;
  while ((match = regex.exec(url)) !== null) {
    const macro = match[1];
    if (SUPPORTED_MACROS.includes(macro)) {
      validMacros.push(macro);
    }
  }
  return validMacros;
}

export function validatePixelUrl(url) {
  const result = { hasError: false, hasErrorWarning: false, errorMessage: "", validMacros: [] };
  if (!url || !url.length) return result;

  if (!isValidURLProtocol(url)) {
    result.hasError = true;
    result.errorMessage =
      "The provided URL uses an invalid protocol. Please ensure that the URL protocol (e.g., 'http://' or 'https://') is correctly specified.";
  } else if (!isValidURLDomain(url)) {
    result.hasError = true;
    result.errorMessage = "The provided URL is not valid";
  } else if (
    (hasCurlyBrakets(url) && !atleastOneValidMacro(url, SUPPORTED_MACROS)) ||
    !areSpecialCharactersValid(url)
  ) {
    result.hasErrorWarning = true;
    const matchingMacros = listOfPossibleMacros(url);
    result.errorMessage = "We suspect you're trying to insert an incorrectly formatted macro.";
    if (matchingMacros.length) {
      result.errorMessage += ` Do you mean ${matchingMacros.join(" or ")}?`;
    }
  }

  result.validMacros = detectValidMacros(url);
  return result;
}
